/* ==========================================================================
   Kenza Pro — Page transition
   Soft fade-out → navigate → fade-in. Internal same-origin links only.
   Carefully handles back/forward (pageshow) so it doesn't look broken.
   ========================================================================== */

(() => {
  if (window.__kpPageTransitionBooted) return;
  window.__kpPageTransitionBooted = true;

  // Hard gates
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return; // theme editor: skip
  if (document.documentElement.dataset.kpPageTransition === 'off') return;

  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const DURATION_OUT = isMobile ? 150 : 200;
  const DURATION_IN  = isMobile ? 150 : 200;

  // ---------- Build fader ----------
  const fader = document.createElement('div');
  fader.className = 'kp-page-fader';
  fader.setAttribute('aria-hidden', 'true');
  document.body.appendChild(fader);

  // Fade in on initial load
  const fadeIn = () => {
    fader.dataset.state = 'out';
    requestAnimationFrame(() => {
      fader.style.transition = `opacity ${DURATION_IN}ms ease`;
      fader.dataset.state = '';
    });
  };

  // pageshow handles both initial load AND back/forward navigation cleanly.
  // The bfcache restores the page in its previous state — we just clear the fader.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      // bfcache restore: skip the fade entirely (would look broken)
      fader.dataset.state = '';
      fader.style.transition = 'none';
    } else {
      fadeIn();
    }
  });

  // ---------- Intercept link clicks ----------
  const isInternal = (url) => {
    try {
      const u = new URL(url, location.href);
      return u.origin === location.origin;
    } catch (_) { return false; }
  };

  document.addEventListener('click', (e) => {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const a = e.target.closest('a[href]');
    if (!a) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download')) return;
    if (a.dataset.noTransition !== undefined) return;
    if (a.getAttribute('href').startsWith('#')) return;
    if (a.getAttribute('href').startsWith('mailto:') || a.getAttribute('href').startsWith('tel:')) return;
    if (!isInternal(a.href)) return;
    if (a.pathname === location.pathname && a.search === location.search) return; // same page

    e.preventDefault();
    fader.style.transition = `opacity ${DURATION_OUT}ms ease`;
    fader.dataset.state = 'out';
    setTimeout(() => { location.href = a.href; }, DURATION_OUT);
  });
})();
